/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

/**
 * Volume statistic per asset compliance dto
 */
export interface AssetDataComplianceDto {
  asset: Asset;
  volume: number;
}
